import { render, staticRenderFns } from "./TesteInputs.vue?vue&type=template&id=65562bae&"
import script from "./TesteInputs.vue?vue&type=script&lang=js&"
export * from "./TesteInputs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports